var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GmapMap',{staticClass:"gmap",staticStyle:{"height":"400px","min-width":"100%"},attrs:{"center":{
                lat: _vm.latitude,
                lng: _vm.longitude,
              },"zoom":14,"map-type-id":"terrain"}},[_c('GmapMarker',{attrs:{"position":{
                  lat: _vm.latitude,
                  lng: _vm.longitude,
                },"clickable":true,"draggable":true},on:{"click":function($event){_vm.center = _vm.m.position}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }